<template>
	<s-box title="Fitro">
		<div slot="body">
			<div class="row">
				<div class="col-sm-2">
					Cód.
					<input
						v-model="filter.cod"
						@change="setFilter"
						type="text"
						class="form-control"
					/>
				</div>
				<div class="col-sm-4">
					Titulo
					<input
						v-model="filter.title"
						@change="setFilter"
						type="text"
						class="form-control"
					/>
				</div>
				<div class="col-sm-3">
					Departamentos
					<select
						@change="setFilter"
						v-model="filter.depto"
						class="form-control"
					>
						<option value="">Todos</option>
						<option
							v-for="(dep, index) in assets.departamentos"
							:key="index"
							:value="dep.cod"
						>
							{{ dep.titulo }}
						</option>
					</select>
				</div>
				<div class="col-sm-3">
					Formulários
					<select
						@change="setFilter"
						v-model="filter.form"
						class="form-control"
					>
						<option value="">Todos</option>
						<option
							v-for="(form, index) in assets.forms"
							:key="index"
							:value="form.cod"
						>
							{{ form.titulo }}
						</option>
					</select>
				</div>
			</div>
		</div>
	</s-box>
</template>
<script>
	import sBox from 'box';
	export default {
		name: 'FilterService',
		components: { sBox },
		inject: ['assets'],
		data() {
			return {
				filter: {
					cod: '',
					title: '',
					depto: '',
					form: '',
				},
			};
		},
		methods: {
			setFilter() {
				this.$emit('setFilter', this.filter);
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/services/filter.vue